import {ComboboxGeneric} from "@/components/ui/combobox-generic";

import {STATUS} from "../../lib";
import {STATUS_MAP} from "../status-badge";

type Status = {
  value: string;
  label: string;
};

type ShiftStatusComboboxProps = {
  value: Status[] | null;
  onChange: (value: Status | Status[] | null) => void;
};

function getStatusLabel(status: string) {
  const label = STATUS_MAP[status as keyof typeof STATUS_MAP] ?? status.replace(/_/g, " ");
  return label.charAt(0).toUpperCase() + label.slice(1);
}

const STATUS_OPTIONS = STATUS.sort((a, b) => a.localeCompare(b)).map((s) => ({
  value: s,
  label: getStatusLabel(s),
}));

export function ShiftStatusCombobox({value, onChange}: ShiftStatusComboboxProps) {
  return (
    <ComboboxGeneric<Status>
      multiple
      items={STATUS_OPTIONS}
      value={value ?? []}
      onChange={onChange}
      getItemKey={(item) => item.value}
      getItemLabel={(item) => item.label}
      isItemEqual={(item, selected) => item.value === selected?.value}
      placeholder="Select status"
      emptyMessage="No statuses found"
    />
  );
}
